import { getShortString } from 'components/core/time/display'
import {
    InventoryAlertSeverity,
    InventoryAlertStatus,
    InventoryAlertType,
} from 'pbts/c1/api/inventory/v1/inventory_alerts'
import { Timestamp as pbtsTimestamp } from 'pbts/google/protobuf/timestamp'
import { IntlShape } from 'react-intl'
import { HistoricalInventoryAlertValue, InventoryAlertValue } from 'redux_toolkit/apps'

export type DisplayAlert = {
    id: string
    title: string
    description: string
    status: InventoryAlertStatus
    detectedOn?: string
    severity: InventoryAlertSeverity
} | null

export const getDisplayAlert = (intl: IntlShape, alertExpanded: InventoryAlertValue | HistoricalInventoryAlertValue): DisplayAlert => {
    const alert = alertExpanded?.inventoryAlert
    if (!alert || !alert.data) {
        return null
    }
    const detectedOn = alertExpanded.inventoryAlert?.createdAt && getShortString({
        d: pbtsTimestamp.toDate(alertExpanded.inventoryAlert.createdAt),
        variant: 'date_only',
    })
    let title = ''
    let description = ''
    const resource = alertExpanded.resource
    switch (alert.data.type) {
        case InventoryAlertType.DEACTIVATED_ACCOUNT_OWNER:
            title = intl.formatMessage({
                id: 'i18n_inventory_alert_deactivated_owner',
                defaultMessage: 'Deactivated responsible party',
            })
            description = intl.formatMessage({
                id: 'i18n_inventory_alert_deactivated_owner_description',
                defaultMessage: 'The responsible party / account owner for this account is no longer active',
            })
            break
        case InventoryAlertType.UNUSED_SECRET_API_TOKEN:
            title = resource?.displayName ? intl.formatMessage(
                {
                    id: 'i18n_inventory_alert_unused_api_token',
                    defaultMessage: 'Unused API Token - {name}',
                },
                {
                    name: resource?.displayName,
                },
            ) : ''
            description = intl.formatMessage({
                id: 'i18n_inventory_alert_unused_api_token_description',
                defaultMessage: 'API Token not used in last 15 days',
            })
            break
        default:
            title = intl.formatMessage({
                id: 'i18n_inventory_alert_unknown',
                defaultMessage: 'Unknown alert',
            })
    }
    return {
        id: alert.id,
        title,
        description,
        detectedOn: intl.formatMessage(
            {
                id: 'i18n_inventory_alert_detected_on',
                defaultMessage: 'Detected on {date}',
            },
            { date: detectedOn },
        ),
        severity: alert.data.severity,
        status: alert.data.status,
    }
}
